module.exports = __webpack_public_path__ + "static/media/super_red_giant.64a72254.png";